export const UIPaths = {
  login: "/login",
  loginPrefilled: "/login/:prefilled",
  register: {
    step1: "/signup",
    step1WithCustomerCode: "/signup/:customerCode?",
    referralSignup: "/referral-signup/:checkoutSessionID",
  },
  forgotPassword: "/forgot-password",
  resetPassword: "/reset-password", //'/reset-password/:magicToken?',
  dashboard: "/dashboard/home",
  // matomoAnalytics: '/store-analytics',
  howTo: {
    list: "/how-to",
    detail: "/how-to/:guideCode",
  },
  unAuthorized: "/misc/not-authorized",
  // attribute: {
  //   list: '/variation/list',
  //   detail: '/variation/detail/:attributeID',
  // },
  // productCategory: {
  //   list: '/product-category/list',
  //   detail: '/product-category/detail/:productCategoryID',
  //   metaData: '/product-category/metadata/:productCategoryID',
  // },
  product: {
    list: "/product/list",
    detail: "/product/detail/:productID",
    images: "/product/images/:productID",
    metaData: "/product/metadata/:productID",
    bulkUpload: "/product/bulkUpload",
  },
  user: {
    list: "/customer/list",
    addNew: "/customer/detail",
    detail: "/customer/detail/:emailID",
    bulkAddTag: "/customer/segementation-add-tag",
    bulkRemoveTag: "/customer/segementation-remove-tag",
  },
  userDashboardMgmt: {
    list: "/user/list",
    newUser: "/user/add",
    detail: "/user/detail/:emailID",
  },
  store: {
    aboutStore: "/about-store",
    contactDetails: "/about-store/contact-details",
    license: "/about-store/manage-subscription",
    appSumoLicense: "/about-store/manage-appsumo-subscription",
    subscriptionPaymentSuccessful: "/subscription-successful",
    licenseDetails: "/about-store/plan-details",
    // subscriptionPaymentCancelled: '/about-store/subscription-payment-cancelled'
  },

  // --------------------------------------------

  entity: {
    list: "/entity/list",
    detail: "/entity/detail/:entityID",
    team: "/entity/team/:entityID",
    manageCompliances: "/entity/manage-compliances/:entityID",
    addCompliances: "/entity/add-compliances",
    policyDocument: "/entity/detail/:entityID/policy/:policyID",
    import: "/entity/import",
    complianceImport: "/entity/compliance-import/:entityID",
    versionHistory: "/entity/:entityID/document-version-history/:parentDocumentID",
    documentTaskDetail: "/entity/:entityID/document-task/:taskNumber",
    taskReport: "/entity/details/:entityID/task-report/:entityComplianceID",
    taskReportDetail: "/entity/details/:entityID/task-report/:entityComplianceID/task-details/:taskNumber",

    // managePolicies: '/entity/manage-policies:entityID'
  },

  repo: {
    complianceList: "/repo/compliance/list",
    complianceWizard: "/repo/compliance/detail/:complianceID",
    policy: {
      list: "/repo/policy/list",
      detail: "/repo/policy/detail/:policyID",
      document: "/repo/policy/document/:policyID",
    },
    circular: {
      regulatorList: "/repo/circulars",
      regulatorDetail: "/repo/circulars/:regulatorTypeCodeID",
    },
    complianceImport: "/repo/compliance/import",
  },
  taskBuilder: {
    list: "/taskBuilder/list",
    detail: "/taskBuilder/detail/:complianceID",
  },
  // policy: {
  //   list: '/repo/policy/list',
  //   detail: '/repo/policy/detail'
  // },
  compliance: {
    categoryCardList: "/compliance/categories",
    listByCategory: "/compliance/categories/:categoryID",
  },

  event: {
    list: "/event/list",
    trigger: "/event/trigger",
    taskList: "/event-tasks/:entityEventID",
  },

  upcomingTask: {
    list: "/pending-tasks",
    detail: "/pending-tasks/:taskNumber",
  },

  allTask: {
    list: "/all-tasks",
    detail: "/all-tasks/:taskNumber",
  },

  complianceLeftMenu: {
    list: "/compliance/list",
    detail: "/compliance/detail",
    assignComplianceToEntities: "/compliance/assign-entities",
  },

  alertBoard: {
    dashboard: "/alert-board",
  },
  complianceBoard: {
    dashboard: "/compliance-board",
    totalTask: {
      taskList: "/compliance-board/tasks",
      taskDetail: "/compliance-board/tasks/:taskNumber",
    },
    compliance: {
      list: "/compliance-board/compliance/list",
    },
    statusWiseTask: {
      taskList: "/compliance-board/progress-tasks",
      taskDetail: "/compliance-board/progress-tasks/:taskNumber",
    },
  },
  cSuiteBoard: {
    dashboard: "/risk-board",
    monetaryRisk: {
      taskList: "/risk-board/monetary-risk-tasks",
      detail: "/risk-board/monetary-risk-tasks/:taskNumber",
    },
    riskMatrix: {
      taskList: "/risk-board/risk-matrix-tasks",
      detail: "/risk-board/risk-matrix-tasks/:taskNumber",
    },
    riskTasks: {
      taskList: "/risk-board/risk-tasks",
      taskDetail: "/risk-board/risk-tasks/:taskNumber",
    },
  },
  auditor: {
    resourcesQuery: "/auditor-resources",
    resourcesResult: "/auditor-resources/result",
    detail: "/audit-details",
    remarks: "/audit-remarks",
  },
  taskTracker: {
    report: "/task-tracker",
    create: "/task-tracker/create-task",
    detail: "/task-tracker/:taskNumber",
    importTask: "/task-tracker/import-task",
  },
  advancedReports: {
    list: "/advanced-reports",
    userPerformanceTaskReport: "/advanced-reports/team-performance-task-list",
    organizationTaskReport: "/advanced-reports/org-task-report",
    userPerformanceTaskReportDetail: "/advanced-reports/team-performance-task-list/task-details/:taskNumber",
    organizationTaskReportDetail: "/advanced-reports/org-task-report/task-details/:taskNumber",
    expectedTaskList: "/advanced-reports/team-performance-expected-task-list",
  },
  user: {
    list: "/user/list",
    detail: "/user/detail/:emailID",
    addNew: "/user/detail",
    import: "/user/import",
  },
  role: {
    list: "/role/list",
    detail: "/role/detail/:roleID",
    addNew: "/role/detail",

    access: "/role/access",
  },

  template: {
    designerView: "/template/designer",
  },
  myProfile: {
    notificationSettings: "/notification-settings",
    notificationList: "/notification-list",
    complianceCalendar: "/compliance-calendar",
  },
  framework: {
    list: "/framework/list",
    detail: "/framework/detail/:frameworkID",
  },
  obligations: {
    list: "/obligations/list",
    detail: "/obligations/detail/:obligationsID",
    import: "/obligations/import",
  },
  vendor: {
    list: "/vendor/list",
    detail: "/vendor/detail/:vendorID",
    login: "/vendor-login/:accessToken",
  },
  entityActorEscalationMatrix: {
    list: "/entityActorEscalationMatrix/list",
  },
  entityComplianceCopy: {
    list: "/entity-compliance/copy",
  }, // PLOP: UI PATHS

  // --------------------------------------------
};

export const SPQueryStringParam = {
  lastModifiedOnDesc: "?q=lmo",
  addCategoryFromProductDetails: "?q=apd",
  restoreSearch: "?q=rsp",
  redirectToPage: "?q=rp-rpt",
  wooCommerceImportFromProductList: "?q=wc",
};
